import { render } from "./SignUpOverlay.vue?vue&type=template&id=81ffe064&scoped=true"
import script from "./SignUpOverlay.vue?vue&type=script&lang=js"
export * from "./SignUpOverlay.vue?vue&type=script&lang=js"

import "./SignUpOverlay.vue?vue&type=style&index=0&id=81ffe064&lang=scss&scoped=true"

import exportComponent from "/Users/christianwidodo/workspace_git/lionsgate/tuwomt/cagespace-site/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ffe064"]])

export default __exports__